// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-ChangeName-styles--group--zXq9H {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
  }

.src-containers-Profile-ChangeName-styles--group--zXq9H > :first-child {
  margin-bottom: 15px;
}

@media screen and (min-width: 768px) {

.src-containers-Profile-ChangeName-styles--group--zXq9H > :first-child {
    margin-right: 10px;
    margin-bottom: 0;
}
  }

@media screen and (min-width: 768px) {

.src-containers-Profile-ChangeName-styles--group--zXq9H > :last-child {
    margin-right: 15px;
    margin-bottom: 0;
}
  }

.src-containers-Profile-ChangeName-styles--status--VTml6 {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/containers/Profile/ChangeName/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACnBE;;AADF;IAEI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAE3B;EADE;;AAGF;EACE,mBAAmB;AAMrB;;AAJE;;AAHF;IAII,kBAAkB;IAClB,gBAAgB;AAEpB;EADE;;AAIA;;AADF;IAEI,kBAAkB;IAClB,gBAAgB;AAEpB;EADE;;AAGF;EACE,aAAa;AACf","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.group {\n  @media (--desktop) {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n  }\n}\n\n.group > :first-child {\n  margin-bottom: 15px;\n\n  @media (--desktop) {\n    margin-right: 10px;\n    margin-bottom: 0;\n  }\n}\n\n.group > :last-child {\n  @media (--desktop) {\n    margin-right: 15px;\n    margin-bottom: 0;\n  }\n}\n\n.status {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `src-containers-Profile-ChangeName-styles--group--zXq9H`,
	"status": `src-containers-Profile-ChangeName-styles--status--VTml6`
};
module.exports = ___CSS_LOADER_EXPORT___;
